import { t } from "i18next";
import { Trans } from "react-i18next";

import { TabType } from "../../atoms";
import { PackagesTabsType } from "./types";

export const PACKAGES_TABS: TabType<PackagesTabsType>[] = [
  {
    id: "CURRENT",
    label: (
      <Trans i18nKey="page.hostedPagesProfilePackages.creditPacksList.tabs.current" />
    ),
  },
  {
    id: "PREVIOUS",
    label: (
      <Trans i18nKey="page.hostedPagesProfilePackages.creditPacksList.tabs.previous" />
    ),
  },
];

export const PACKAGES_TABS_SELECT = [
  {
    id: "CURRENT",
    label: t("page.hostedPagesProfilePackages.creditPacksList.tabs.current"),
    value: "CURRENT",
  } as const,
  {
    id: "PREVIOUS",
    label: t("page.hostedPagesProfilePackages.creditPacksList.tabs.previous"),
    value: "PREVIOUS",
  } as const,
];
